import { languages, defaultLocale } from "../translations/translations";

export default {
  title: process.env.VUE_APP_TITLE,
  languages,
  defaultLocale,
  busy: false,
  baseApiUrl: "",
  error: { message: "", allowRefresh: true, allowClose: true },
};
